import React from 'react'

import { useParams } from 'react-router-dom'
import { useSearchQuery } from 'src/hooks/useSearchQuery'
import { useAppSelect } from '../useApp'
import { ObjectPageTabs } from 'src/pages/storage/object/id/components/CompanyChat/types'

export { ObjectPageTabs }
interface ISelectedChildren {
  schemeName: string
  objectUniqId?: string
}

export interface IUseRouterObjectPageSearchQuery {
  objectPage?: {
    selectedChildren?: ISelectedChildren
    selectedTab?: ObjectPageTabs
    [ObjectPageTabs.MESSAGES]?: {
      initialMessage: string
    }
  }
}

export const useRouterObjectPage = () => {
  const search = useSearchQuery<IUseRouterObjectPageSearchQuery>()
  const { objectId: objectUniqId = '', schemeName = '' } = useParams<{
    objectId: string
    schemeName: string
  }>()
  const schemes = useAppSelect.schemas()

  const objectScheme = React.useMemo(
    () => schemes.find((item) => item.identifier === schemeName),
    [schemeName, schemes]
  )
  const objectChildScheme = React.useMemo(
    () =>
      search.query.objectPage?.selectedChildren?.schemeName
        ? schemes.find(
            (item) =>
              item.identifier ===
              search.query.objectPage?.selectedChildren?.schemeName
          )
        : null,
    [search.query.objectPage?.selectedChildren?.schemeName, schemes]
  )

  const selectObjectChildren = (props: ISelectedChildren) => {
    search.setQuery({
      objectPage: {
        ...search.query.objectPage,
        selectedChildren: props,
      },
    })
  }

  const selectObjectChildrenPath = (path: string, props: ISelectedChildren) => {
    search.setPathQuery(path, {
      objectPage: {
        ...search.query.objectPage,
        selectedChildren: props,
      },
    })
  }

  const selectObjectTab = (tab: ObjectPageTabs) => {
    search.setQuery({
      objectPage: {
        ...search.query.objectPage,
        selectedTab: tab,
      },
    })
  }
  const clearObjectChildrenSelected = () => {
    search.setQuery({
      objectPage: {
        ...search.query.objectPage,
        selectedChildren: search.query?.objectPage?.selectedChildren
          ? {
              ...search.query?.objectPage?.selectedChildren,
              objectUniqId: undefined,
            }
          : undefined,
      },
    })
  }
  const close = (path: string) => {
    search.setPathQuery(path, {
      objectPage: undefined,
    })
  }

  return {
    search,
    ...search.query.objectPage,
    objectUniqId,
    objectScheme,
    objectChildScheme,
    schemeName,
    selectObjectTab,
    close,
    selectObjectChildren,
    selectObjectChildrenPath,
    clearObjectChildrenSelected,
  }
}
